var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ai-check-container" }, [
    _vm._m(0),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: !_vm.actionStatusesReady,
            expression: "!actionStatusesReady",
          },
        ],
        staticClass: "glass-card",
      },
      [
        _vm.actionStatusesReady
          ? _c(
              "el-tabs",
              {
                staticClass: "sk-tabs",
                attrs: { type: "card" },
                model: {
                  value: _vm.activeTab,
                  callback: function ($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab",
                },
              },
              [
                _vm.hasS3Actions
                  ? _c("el-tab-pane", { attrs: { name: "s3_storage" } }, [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("i", { staticClass: "el-icon-upload" }),
                        _vm._v(" Lưu trữ & AWS S3\n        "),
                      ]),
                      _c(
                        "div",
                        { staticClass: "tab-pane-content" },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _vm.isTransfer === "Hoạt động"
                                ? _c(
                                    "el-col",
                                    {
                                      staticClass: "mb-4",
                                      attrs: { xs: 24, lg: 12 },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-section" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "section-header-row",
                                            },
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "section-divider",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-upload",
                                                  }),
                                                  _vm._v(
                                                    " ĐỒNG BỘ ẢNH TỪ MÁY CHỦ LÊN AWS S3\n                  "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "status-badge",
                                                  class:
                                                    _vm.isTransfer ===
                                                    "Hoạt động"
                                                      ? "online"
                                                      : "offline",
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass: "dot",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.isTransfer) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            { staticClass: "section-desc" },
                                            [
                                              _vm._v(
                                                "\n                  Đồng bộ và đẩy tệp hình ảnh từ máy chủ cục bộ lên dịch vụ lưu trữ đám mây S3 Amazon.\n                "
                                              ),
                                            ]
                                          ),
                                          _vm.transferDate
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "notice-box info mb-3",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-info",
                                                  }),
                                                  _c("span", [
                                                    _vm._v(
                                                      "Giới hạn an toàn: Chỉ được chuyển dữ liệu phát sinh trước ngày "
                                                    ),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(_vm.transferDate)
                                                      ),
                                                    ]),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-item-block mb-3",
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "item-label" },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-date",
                                                  }),
                                                  _vm._v(
                                                    " Khoảng thời gian áp dụng:"
                                                  ),
                                                ]
                                              ),
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  type: "daterange",
                                                  align: "left",
                                                  "unlink-panels": "",
                                                  "range-separator": "đến",
                                                  "start-placeholder":
                                                    "Từ ngày",
                                                  "end-placeholder": "Đến ngày",
                                                  format: "dd/MM/yyyy",
                                                  "value-format": "yyyy-MM-dd",
                                                  "picker-options":
                                                    _vm.pickerOptions,
                                                },
                                                on: {
                                                  change:
                                                    _vm.handleDateRangeS3Change,
                                                },
                                                model: {
                                                  value: _vm.dateRangeS3,
                                                  callback: function ($$v) {
                                                    _vm.dateRangeS3 = $$v
                                                  },
                                                  expression: "dateRangeS3",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "section-action-footer",
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass:
                                                    "gradient-btn green-btn",
                                                  attrs: {
                                                    icon: "el-icon-upload2",
                                                    size: "medium",
                                                    disabled:
                                                      _vm.isTransfer ===
                                                        "Ngừng hoạt động" ||
                                                      _vm.showCheckBoxS3,
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.transferDataServerToS3,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Chọn trường & Chuyển ảnh lên S3\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isDeleteAlbum === "Hoạt động"
                                ? _c(
                                    "el-col",
                                    {
                                      staticClass: "mb-4",
                                      attrs: { xs: 24, lg: 12 },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-section" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "section-header-row",
                                            },
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "section-divider",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-delete",
                                                  }),
                                                  _vm._v(
                                                    " XÓA ALBUM TRÊN MÁY CHỦ & AWS S3\n                  "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "status-badge",
                                                  class:
                                                    _vm.isDeleteAlbum ===
                                                    "Hoạt động"
                                                      ? "online"
                                                      : "offline",
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass: "dot",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.isDeleteAlbum
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            { staticClass: "section-desc" },
                                            [
                                              _vm._v(
                                                "\n                  Dọn dẹp và xóa hoàn toàn album ảnh trên cả hai máy chủ theo khoảng thời gian đã chọn.\n                "
                                              ),
                                            ]
                                          ),
                                          _vm.transferDate
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "notice-box warning mb-3",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-warning-outline",
                                                  }),
                                                  _c("span", [
                                                    _vm._v(
                                                      "Ràng buộc: Không được xóa album sau ngày "
                                                    ),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(_vm.transferDate)
                                                      ),
                                                    ]),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-item-block mb-3",
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "item-label" },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-date",
                                                  }),
                                                  _vm._v(
                                                    " Khoảng thời gian xóa album:"
                                                  ),
                                                ]
                                              ),
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  type: "daterange",
                                                  align: "left",
                                                  "unlink-panels": "",
                                                  "range-separator": "đến",
                                                  "start-placeholder":
                                                    "Từ ngày",
                                                  "end-placeholder": "Đến ngày",
                                                  format: "dd/MM/yyyy",
                                                  "value-format": "yyyy-MM-dd",
                                                  "picker-options":
                                                    _vm.pickerOptions,
                                                },
                                                on: {
                                                  change:
                                                    _vm.handleDateRangeDeleteS3Change,
                                                },
                                                model: {
                                                  value: _vm.dateRangeDeleteS3,
                                                  callback: function ($$v) {
                                                    _vm.dateRangeDeleteS3 = $$v
                                                  },
                                                  expression:
                                                    "dateRangeDeleteS3",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "section-action-footer",
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass:
                                                    "gradient-btn red-btn",
                                                  attrs: {
                                                    icon: "el-icon-delete",
                                                    size: "medium",
                                                    disabled:
                                                      _vm.isDeleteAlbum ===
                                                        "Ngừng hoạt động" ||
                                                      _vm.showCheckBoxS3,
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.deleteDateServerAndS3,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Chọn trường & Xóa album\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isScanPictureExitOnS3 === "Hoạt động"
                                ? _c(
                                    "el-col",
                                    {
                                      staticClass: "mb-4",
                                      attrs: { xs: 24, lg: 12 },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-section" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "section-header-row",
                                            },
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "section-divider",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-view",
                                                  }),
                                                  _vm._v(
                                                    " QUÉT KIỂM TRA TÍNH TOÀN VẸN ẢNH S3\n                  "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "status-badge",
                                                  class:
                                                    _vm.isScanPictureExitOnS3 ===
                                                    "Hoạt động"
                                                      ? "online"
                                                      : "offline",
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass: "dot",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.isScanPictureExitOnS3
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            { staticClass: "section-desc" },
                                            [
                                              _vm._v(
                                                "\n                  Kiểm tra tính toàn vẹn; nếu phát hiện ảnh thiếu trên S3, hệ thống sẽ tự động đồng bộ lại.\n                "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-item-block mb-3",
                                            },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "item-label" },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-date",
                                                  }),
                                                  _vm._v(
                                                    " Khoảng thời gian quét ảnh:"
                                                  ),
                                                ]
                                              ),
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  type: "daterange",
                                                  align: "left",
                                                  "unlink-panels": "",
                                                  "range-separator": "đến",
                                                  "start-placeholder":
                                                    "Từ ngày",
                                                  "end-placeholder": "Đến ngày",
                                                  format: "dd/MM/yyyy",
                                                  "value-format": "yyyy-MM-dd",
                                                  "picker-options":
                                                    _vm.pickerOptions,
                                                },
                                                on: {
                                                  change:
                                                    _vm.handleDateRangeScanS3Change,
                                                },
                                                model: {
                                                  value: _vm.dateRangeScanS3,
                                                  callback: function ($$v) {
                                                    _vm.dateRangeScanS3 = $$v
                                                  },
                                                  expression: "dateRangeScanS3",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "section-action-footer",
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass:
                                                    "gradient-btn blue-btn",
                                                  attrs: {
                                                    icon: "el-icon-search",
                                                    size: "medium",
                                                    disabled:
                                                      _vm.isScanPictureExitOnS3 ===
                                                      "Ngừng hoạt động",
                                                    loading:
                                                      _vm.loadingScanPictureExitS3,
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.scanPictureExitS3Amazon,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Tiến hành quét ảnh S3\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasPhotoCleanupActions
                                ? _c(
                                    "el-col",
                                    {
                                      staticClass: "mb-4",
                                      attrs: { xs: 24, lg: 12 },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-section" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "section-header-row",
                                            },
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "section-divider",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-brush",
                                                  }),
                                                  _vm._v(
                                                    " DỌN DẸP ẢNH RÁC & ẢNH ĐÃ XÓA THỦ CÔNG\n                  "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "status-badge online",
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass: "dot",
                                                  }),
                                                  _vm._v(
                                                    " Hoạt động\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            { staticClass: "section-desc" },
                                            [
                                              _vm._v(
                                                "\n                  Quét dọn các tệp ảnh rác không còn liên kết và giải phóng dung lượng từ ảnh đã xóa thủ công.\n                "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "dual-action-grid",
                                              class: {
                                                "single-action":
                                                  _vm.isDeleteRedundantPhotoOnServer !==
                                                  _vm.isDeleteS3SVHandMade,
                                              },
                                            },
                                            [
                                              _vm.isDeleteRedundantPhotoOnServer ===
                                              "Hoạt động"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "action-sub-box",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "sub-box-title",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-folder-delete text-purple",
                                                          }),
                                                          _vm._v(
                                                            " Dọn ảnh rác theo trường\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "sub-box-desc",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Lựa chọn từng trường, năm & tháng áp dụng dọn ảnh."
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          staticClass:
                                                            "gradient-btn purple-btn",
                                                          attrs: {
                                                            icon: "el-icon-brush",
                                                            size: "small",
                                                            disabled:
                                                              _vm.isDeleteRedundantPhotoOnServer ===
                                                              "Ngừng hoạt động",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.openDeleteRedundantPhotoDialog,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      Chọn trường & Dọn ảnh rác\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.isDeleteS3SVHandMade ===
                                              "Hoạt động"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "action-sub-box",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "sub-box-title",
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-delete text-red",
                                                          }),
                                                          _vm._v(
                                                            " Dọn ảnh đã xóa thủ công\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "sub-box-desc",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Giải phóng dung lượng từ các ảnh đã bị người dùng xóa."
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          staticClass:
                                                            "gradient-btn red-btn",
                                                          attrs: {
                                                            icon: "el-icon-delete",
                                                            size: "small",
                                                            disabled:
                                                              _vm.isDeleteS3SVHandMade ===
                                                              "Ngừng hoạt động",
                                                            loading:
                                                              _vm.buttonLoadingS3SVHandMade,
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.deleteS3SVHandMade,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      Dọn dẹp ngay\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm.isDeleteDataBase === "Hoạt động"
                  ? _c("el-tab-pane", { attrs: { name: "database_cleanup" } }, [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("i", { staticClass: "el-icon-coin" }),
                        _vm._v(" Dọn dẹp CSDL lớn\n        "),
                      ]),
                      _c("div", { staticClass: "tab-pane-content" }, [
                        _c(
                          "div",
                          { staticClass: "form-section" },
                          [
                            _c("div", { staticClass: "section-header-row" }, [
                              _c("h4", { staticClass: "section-divider" }, [
                                _c("i", { staticClass: "el-icon-coin" }),
                                _vm._v(
                                  " BẢO TRÌ & GIẢI PHÓNG DUNG LƯỢNG BẢNG CƠ SỞ DỮ LIỆU LỚN\n              "
                                ),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "status-badge",
                                  class:
                                    _vm.isDeleteDataBase === "Hoạt động"
                                      ? "online"
                                      : "offline",
                                },
                                [
                                  _c("span", { staticClass: "dot" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.isDeleteDataBase) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _c("p", { staticClass: "section-desc" }, [
                              _vm._v(
                                "\n              Thực hiện giải phóng dung lượng cho các bảng lịch sử (nhận xét, điểm danh) đã lưu trữ lâu năm trong cơ sở dữ liệu.\n            "
                              ),
                            ]),
                            _c(
                              "el-row",
                              { staticClass: "mb-4", attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { xs: 24, md: 10 } }, [
                                  _c(
                                    "div",
                                    { staticClass: "form-item-block" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "item-label" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-s-grid",
                                          }),
                                          _vm._v(
                                            " Chọn bảng dữ liệu cần bảo trì:"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            placeholder: "Chọn bảng dữ liệu...",
                                          },
                                          on: {
                                            change: _vm.handleChangeOption,
                                          },
                                          model: {
                                            value: _vm.selectedOption,
                                            callback: function ($$v) {
                                              _vm.selectedOption = $$v
                                            },
                                            expression: "selectedOption",
                                          },
                                        },
                                        _vm._l(_vm.options, function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm.selectedOption !== "" && _vm.dataInfo
                                  ? _c(
                                      "el-col",
                                      { attrs: { xs: 24, md: 14 } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "stat-mini-container",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "stat-mini-box" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "stat-mini-title",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-tickets",
                                                    }),
                                                    _vm._v(
                                                      " Số lượng bản ghi:"
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "stat-mini-number",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatNumber(
                                                          _vm.TABLE_ROWS
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c("div", {
                                              staticClass: "stat-mini-divider",
                                            }),
                                            _c(
                                              "div",
                                              { staticClass: "stat-mini-box" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "stat-mini-title",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-pie-chart",
                                                    }),
                                                    _vm._v(
                                                      " Dung lượng ước tính:"
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "stat-mini-number highlight",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatNumber(
                                                          _vm.DATA_LENGTH
                                                        )
                                                      ) + " MB"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              { staticClass: "mb-3", attrs: { gutter: 20 } },
                              [
                                _c("el-col", { attrs: { xs: 24, md: 14 } }, [
                                  _c(
                                    "div",
                                    { staticClass: "form-item-block" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "item-label" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-date",
                                          }),
                                          _vm._v(
                                            " Khoảng thời gian xóa dữ liệu:"
                                          ),
                                        ]
                                      ),
                                      _c("el-date-picker", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "daterange",
                                          align: "left",
                                          "unlink-panels": "",
                                          "range-separator": "đến",
                                          "start-placeholder": "Từ ngày",
                                          "end-placeholder": "Đến ngày",
                                          format: "dd/MM/yyyy",
                                          "value-format": "yyyy-MM-dd",
                                          "picker-options": _vm.pickerOptions,
                                        },
                                        on: {
                                          change: _vm.handleDateRangeDBChange,
                                        },
                                        model: {
                                          value: _vm.dateRangeDB,
                                          callback: function ($$v) {
                                            _vm.dateRangeDB = $$v
                                          },
                                          expression: "dateRangeDB",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "notice-box warning mb-3" },
                              [
                                _c("i", { staticClass: "el-icon-warning" }),
                                _c("div", [
                                  _c("strong", [
                                    _vm._v("Quy tắc an toàn hệ thống:"),
                                  ]),
                                  _vm._v(
                                    "\n                Chỉ cho phép xóa dữ liệu lịch sử đã lưu trữ trên "
                                  ),
                                  _c("strong", [_vm._v("1 năm (≥ 366 ngày)")]),
                                  _vm._v(
                                    " so với ngày hiện tại. Thao tác xóa CSDL không thể hoàn tác!\n              "
                                  ),
                                ]),
                              ]
                            ),
                            _vm.responseRowDeleted
                              ? _c(
                                  "div",
                                  { staticClass: "result-alert-box mb-3" },
                                  [
                                    _c("i", { staticClass: "el-icon-info" }),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.responseRowDeleted)),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "section-action-footer" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "gradient-btn red-btn",
                                    attrs: {
                                      icon: "el-icon-delete",
                                      size: "medium",
                                      disabled:
                                        _vm.isDeleteDataBase ===
                                        "Ngừng hoạt động",
                                      loading: _vm.buttonLoading,
                                    },
                                    on: { click: _vm.deleteBigData },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.nameDelete) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm.hasMigrationActions
                  ? _c("el-tab-pane", { attrs: { name: "data_migration" } }, [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("i", { staticClass: "el-icon-refresh" }),
                        _vm._v(" Chuyển đổi dữ liệu V4\n        "),
                      ]),
                      _c(
                        "div",
                        { staticClass: "tab-pane-content" },
                        [
                          _c(
                            "el-row",
                            {
                              staticClass: "migration-card-grid",
                              attrs: { gutter: 20, type: "flex" },
                            },
                            [
                              _vm.hasSchoolDataMigrationAction
                                ? _c(
                                    "el-col",
                                    {
                                      staticClass: "mb-4",
                                      attrs: { xs: 24, md: 12 },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-section" },
                                        [
                                          _c(
                                            "h4",
                                            { staticClass: "section-divider" },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-refresh",
                                              }),
                                              _vm._v(
                                                " CHUYỂN ĐỔI ĐIỂM DANH VÀ NHẬN XÉT V4\n                "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            { staticClass: "section-desc" },
                                            [
                                              _vm._v(
                                                "\n                  Chuyển điểm danh và bốn loại nhận xét cho nhiều trường trong một lần thực hiện.\n                "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "feature-checklist mb-4",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "check-item" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-check",
                                                  }),
                                                  _vm._v(
                                                    " Chọn danh sách trường, khoảng ngày và dữ liệu cần chuyển"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "check-item" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-check",
                                                  }),
                                                  _vm._v(
                                                    " Chạy ngay hoặc lưu yêu cầu chờ cronjob"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "check-item" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-check",
                                                  }),
                                                  _vm._v(
                                                    " Theo dõi tiến độ và kết quả chuyển đổi từng trường"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "section-action-footer school-migration-actions",
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    icon: "el-icon-tickets",
                                                    size: "medium",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.handleOpenSchoolMigrationJobs,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Yêu cầu chuyển đổi\n                  "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass:
                                                    "gradient-btn blue-btn",
                                                  attrs: {
                                                    icon: "el-icon-refresh",
                                                    size: "medium",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.handleOpenSchoolMigration,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Chuyển đổi nhiều trường\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasSchoolDataMigrationAction
                                ? _c(
                                    "el-col",
                                    {
                                      staticClass: "mb-4",
                                      attrs: { xs: 24, md: 12 },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-section" },
                                        [
                                          _c(
                                            "h4",
                                            { staticClass: "section-divider" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-edit-outline",
                                              }),
                                              _vm._v(
                                                " CHUYỂN ĐỔI NHẬN XÉT HỌC SINH SANG V4\n                "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            { staticClass: "section-desc" },
                                            [
                                              _vm._v(
                                                "\n                  Đồng bộ và di chuyển dữ liệu nhận xét (ngày, tuần, tháng, định kỳ) sang cấu trúc V4 mới tối ưu tốc độ.\n                "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "feature-checklist mb-4",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "check-item" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-check",
                                                  }),
                                                  _vm._v(
                                                    " Chuyển đổi linh hoạt theo từng trường hoặc toàn bộ"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "check-item" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-check",
                                                  }),
                                                  _vm._v(
                                                    " Hỗ trợ lọc theo loại nhận xét và khoảng thời gian"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "check-item" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-check",
                                                  }),
                                                  _vm._v(
                                                    " Cơ chế an toàn: Bỏ qua dữ liệu đã tồn tại, không ghi đè"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "section-action-footer",
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass:
                                                    "gradient-btn blue-btn",
                                                  attrs: {
                                                    icon: "el-icon-refresh",
                                                    size: "medium",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.handleOpenMigrationEvaluation,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Mở công cụ chuyển đổi nhận xét V4\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasSchoolDataMigrationAction
                                ? _c(
                                    "el-col",
                                    {
                                      staticClass: "mb-4",
                                      attrs: { xs: 24, md: 12 },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-section" },
                                        [
                                          _c(
                                            "h4",
                                            { staticClass: "section-divider" },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-finished",
                                              }),
                                              _vm._v(
                                                " CHUYỂN ĐỔI ĐIỂM DANH HỌC SINH SANG V4\n                "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            { staticClass: "section-desc" },
                                            [
                                              _vm._v(
                                                "\n                  Chuyển đổi và chuẩn hoá dữ liệu điểm danh sang phiên bản V4 đảm bảo tính chính xác và hiệu năng truy vấn.\n                "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "feature-checklist mb-4",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "check-item" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-check",
                                                  }),
                                                  _vm._v(
                                                    " Đồng bộ dữ liệu điểm danh đến và về"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "check-item" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-check",
                                                  }),
                                                  _vm._v(
                                                    " Tùy chọn khoảng ngày di chuyển an toàn"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "check-item" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-check",
                                                  }),
                                                  _vm._v(
                                                    " Báo cáo tổng hợp số lượng bản ghi thành công/thất bại"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "section-action-footer",
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass:
                                                    "gradient-btn green-btn",
                                                  attrs: {
                                                    icon: "el-icon-refresh",
                                                    size: "medium",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.handleOpenMigrationAttendance,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Mở công cụ chuyển đổi điểm danh V4\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasAlbumLegacySyncAction
                                ? _c(
                                    "el-col",
                                    {
                                      staticClass: "mb-4",
                                      attrs: { xs: 24, md: 12 },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-section" },
                                        [
                                          _c(
                                            "h4",
                                            { staticClass: "section-divider" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-picture-outline",
                                              }),
                                              _vm._v(
                                                " ĐỒNG BỘ ALBUM CŨ SANG ALBUM MỚI\n                "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            { staticClass: "section-desc" },
                                            [
                                              _vm._v(
                                                "\n                  Đồng bộ album trường/lớp từ dữ liệu cũ sang Album mới, giữ nguyên thông tin album và metadata storage ảnh.\n                "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "feature-checklist mb-4",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "check-item" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-check",
                                                  }),
                                                  _vm._v(
                                                    " Chọn một trường hoặc toàn bộ trường theo khoảng ngày"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "check-item" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-check",
                                                  }),
                                                  _vm._v(
                                                    " Chỉ chuyển album và ảnh còn hoạt động"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "check-item" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-check",
                                                  }),
                                                  _vm._v(
                                                    " Bỏ qua và đánh dấu album đã đồng bộ thành công"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "section-action-footer",
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass:
                                                    "gradient-btn purple-btn",
                                                  attrs: {
                                                    icon: "el-icon-picture-outline",
                                                    size: "medium",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.handleOpenAlbumLegacySync,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Mở công cụ đồng bộ album\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _c("el-tab-pane", { attrs: { name: "system_utilities" } }, [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("i", { staticClass: "el-icon-cpu" }),
                    _vm._v(" Tiện ích & Tích hợp\n        "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "tab-pane-content" },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            {
                              staticClass: "mb-4",
                              attrs: { xs: 24, md: 12, lg: 8 },
                            },
                            [
                              _c("div", { staticClass: "form-section" }, [
                                _c("h4", { staticClass: "section-divider" }, [
                                  _c("i", {
                                    staticClass: "el-icon-refresh-right",
                                  }),
                                  _vm._v(
                                    " KHỞI ĐỘNG CẤU HÌNH S3 AMAZON\n                "
                                  ),
                                ]),
                                _c("p", { staticClass: "section-desc" }, [
                                  _vm._v(
                                    "\n                  Tải lại và làm mới các tham số cấu hình kết nối đám mây AWS S3 khi có cập nhật Secret Key, Access Key hoặc thay đổi bucket.\n                "
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "notice-box info mb-3" },
                                  [
                                    _c("i", { staticClass: "el-icon-info" }),
                                    _c("span", [
                                      _vm._v(
                                        "Áp dụng ngay cấu hình mới mà không cần khởi động lại dịch vụ máy chủ."
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "section-action-footer" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "gradient-btn blue-btn",
                                        attrs: {
                                          icon: "el-icon-refresh",
                                          size: "medium",
                                          loading:
                                            _vm.loadingRestartConfiguration,
                                        },
                                        on: { click: _vm.restartConfiguration },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Khởi động lại S3\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "el-col",
                            {
                              staticClass: "mb-4",
                              attrs: { xs: 24, md: 12, lg: 8 },
                            },
                            [
                              _c("div", { staticClass: "form-section" }, [
                                _c("h4", { staticClass: "section-divider" }, [
                                  _c("i", { staticClass: "el-icon-lightning" }),
                                  _vm._v(
                                    " WEBHOOK THANH TOÁN TRỰC TUYẾN\n                "
                                  ),
                                ]),
                                _c("p", { staticClass: "section-desc" }, [
                                  _vm._v(
                                    "\n                  Kiểm tra đường truyền webhook và tình trạng tiếp nhận thông báo thanh toán tự động từ cổng kết nối SePay.\n                "
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "notice-box info mb-3" },
                                  [
                                    _c("i", { staticClass: "el-icon-info" }),
                                    _c("span", [
                                      _vm._v(
                                        "Gửi gói tin kiểm tra kết nối tới máy chủ endpoint thanh toán SePay."
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "section-action-footer" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "gradient-btn green-btn",
                                        attrs: {
                                          icon: "el-icon-lightning",
                                          size: "medium",
                                          loading: _vm.loadingCheckWebHook,
                                        },
                                        on: { click: _vm.checkWebHook },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Kiểm tra Webhook\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "el-col",
                            {
                              staticClass: "mb-4",
                              attrs: { xs: 24, md: 12, lg: 8 },
                            },
                            [
                              _c("div", { staticClass: "form-section" }, [
                                _c("h4", { staticClass: "section-divider" }, [
                                  _c("i", { staticClass: "el-icon-camera" }),
                                  _vm._v(
                                    " CHẾ ĐỘ NHẬN DIỆN KHUÔN MẶT AI\n                "
                                  ),
                                ]),
                                _c("p", { staticClass: "section-desc" }, [
                                  _vm._v(
                                    "\n                  Cập nhật và đồng bộ trạng thái kích hoạt nhận diện khuôn mặt AI theo từng trường học đến các máy điểm danh.\n                "
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "notice-box info mb-3" },
                                  [
                                    _c("i", { staticClass: "el-icon-info" }),
                                    _c("span", [
                                      _vm._v(
                                        "Áp dụng thay đổi cấu hình điểm danh AI trên toàn bộ hệ thống máy điểm danh."
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "section-action-footer" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "gradient-btn purple-btn",
                                        attrs: {
                                          icon: "el-icon-camera",
                                          size: "medium",
                                          loading: _vm.loadingChangAI,
                                        },
                                        on: { click: _vm.handleChangeAI },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Cập nhật cấu hình AI\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      [
        _c("SchoolSelectConfigS3Dialog", {
          attrs: {
            checkSchoolSelect: _vm.checkSchoolSelect,
            isTransfer: _vm.isTransfer,
            dateStart: _vm.dateStart,
            dateEnd: _vm.dateEnd,
          },
          on: {
            close: _vm.handleCloseSchoolSelect,
            childEvent: _vm.handleChildEventTransfer,
          },
        }),
        _c("DeletePictureServerAndS3Dialog", {
          attrs: {
            checkSchoolSelectDelete: _vm.checkSchoolSelectDelete,
            isDeleteAlbum: _vm.isDeleteAlbum,
            dateStart: _vm.dateStart,
            dateEnd: _vm.dateEnd,
          },
          on: {
            close: _vm.handleCloseSchoolSelectDelete,
            childEvent: _vm.handleChildEventDelete,
          },
        }),
        _c("DeleteRedundantPhotosDialog", {
          attrs: {
            showDeleteRedundantPhotoOnServer:
              _vm.showDeleteRedundantPhotoOnServer,
          },
          on: {
            close: _vm.closeDeleteRedundantPhotoOnServerDialog,
            childEvent: _vm.handleChildEventDeleteRedundantPhotos,
          },
        }),
        _c("DeleteDataTurnOffAutomaticInvoiceGeneration", {
          attrs: {
            showTurnOffAutomaticInvoiceGenerationDialog:
              _vm.showTurnOffAutomaticInvoiceGenerationDialog,
            dateStart: _vm.dateStart,
            dateEnd: _vm.dateEnd,
          },
          on: { close: _vm.handleCloseTurnOffAutomaticInvoiceGeneration },
        }),
        _vm.hasSchoolDataMigrationAction
          ? _c("SchoolDataMigrationPanel", {
              ref: "schoolDataMigration",
              attrs: {
                "school-list": _vm.schoolList,
                active: _vm.activeTab === "data_migration",
              },
            })
          : _vm._e(),
        _vm.hasSchoolDataMigrationAction
          ? _c("MigrationAttendanceDialog", {
              attrs: {
                "dialog-visible": _vm.showMigrationAttendanceDialog,
                "school-list": _vm.schoolList,
              },
              on: { close: _vm.handleCloseMigrationAttendance },
            })
          : _vm._e(),
        _vm.hasSchoolDataMigrationAction
          ? _c("MigrationEvaluationDialog", {
              attrs: {
                "dialog-visible": _vm.showMigrationEvaluationDialog,
                "school-list": _vm.schoolList,
              },
              on: { close: _vm.handleCloseMigrationEvaluation },
            })
          : _vm._e(),
        _vm.hasAlbumLegacySyncAction
          ? _c("AlbumLegacySyncDialog", {
              attrs: {
                "dialog-visible": _vm.showAlbumLegacySyncDialog,
                "school-list": _vm.schoolList,
              },
              on: { close: _vm.handleCloseAlbumLegacySync },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ai-header-banner" }, [
      _c("div", { staticClass: "banner-overlay" }),
      _c("div", { staticClass: "banner-content" }, [
        _c("div", { staticClass: "banner-left" }, [
          _c("div", { staticClass: "ai-icon-pulse" }, [
            _c("i", { staticClass: "el-icon-data-analysis" }),
          ]),
          _c("div", [
            _c("h1", { staticClass: "banner-title" }, [
              _vm._v("QUẢN LÝ DỮ LIỆU HỆ THỐNG"),
            ]),
            _c("p", { staticClass: "banner-subtitle" }, [
              _vm._v(
                "\n            Trung tâm quản trị lưu trữ AWS S3, bảo trì dung lượng CSDL lớn, chuyển đổi dữ liệu V4 & kiểm tra dịch vụ tích hợp.\n          "
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }